<!-- Frontend -->
<h1 class="areaHeading pt-5 pb-2 mt-5">Technologies</h1>

<div class="flex-container">
    <div class="flex-item">
        <app-technical-skills-card [technicalSkill]="technicalSkills[0]"></app-technical-skills-card>
        <app-technical-skills-card [technicalSkill]="technicalSkills[4]"></app-technical-skills-card>
    </div>
    <div class="flex-item">
        <app-technical-skills-card [technicalSkill]="technicalSkills[1]"></app-technical-skills-card>
        <app-technical-skills-card [technicalSkill]="technicalSkills[2]"></app-technical-skills-card>
    </div>
    <div class="flex-item">
        <app-technical-skills-card [technicalSkill]="technicalSkills[3]"></app-technical-skills-card>
        <app-technical-skills-card [technicalSkill]="technicalSkills[5]"></app-technical-skills-card>
    </div>
</div>
